import React from "react";
import { Flex, Notification, Box, P } from "orcs-design-system";
import { useOrgAnnouncement } from "src/hooks/orgConfig/hooks/useOrgAnnouncement";

const GlobalNotification = () => {
  const { announcement } = useOrgAnnouncement();
  const { message, colour, visualTreatment } = announcement ?? {};

  switch (visualTreatment) {
    case "top-banner":
      return (
        <Box
          bg={colour === "default" ? "primaryLighter" : `${colour}Lightest`}
          dataTestId="notification-top-banner"
          id="notification-top-banner"
          py="xs"
        >
          <Flex width="100%" justifyContent="center" px="s">
            <P color="black90" fontWeight="600" fontSize="1.3rem">
              {message}
            </P>
          </Flex>
        </Box>
      );
    case "bottom-banner":
      return (
        <Notification
          floating
          centered
          bottom="20px"
          colour={colour}
          closable={false}
          altStyle
        >
          {message}
        </Notification>
      );
    default:
      return null;
  }
};

export default GlobalNotification;
